import { render, staticRenderFns } from "./MarketForm.vue?vue&type=template&id=4412e076&scoped=true&"
import script from "./MarketForm.vue?vue&type=script&lang=js&"
export * from "./MarketForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4412e076",
  null
  
)

export default component.exports